<template>
  <div class="text-sm h-full flex flex-col">
    <!-- 应急预案成员 -->
    <div class="text-white">
      <CategoryTitle class="my-10px" title="应急预案成员" />
      <div class="px-5 max-h-100px overflow-y-auto">{{ emergencyPlanPerson.join('，') }}</div>
    </div>
    <!-- 重要机组参数 -->
    <div class="text-white" v-if="importantGroupsParams.length > 0">
      <CategoryTitle class="my-10px" title="重要机组参数" />
      <div class="max-h-175px overflow-y-auto">
        <div
          class="mb-10px border-hex-20656d border-1 rounded-md py-2"
          v-for="(item, index) in importantGroupsParams"
          :key="index"
        >
          <el-row class="flex mb-1" v-for="(it, ind) in importantGroups" :key="ind">
            <el-col :span="5">
              <div class="text-[#c3c3c3] text-right">{{ it[0] }}：</div>
            </el-col>
            <el-col :span="19">
              <el-tooltip
                :content="item[it[1]]"
                placement="top"
                :open-delay="500"
                :disabled="!item[it[1]]"
              >
                <div class="flex-1 truncate">{{ item[it[1]] }}</div>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 三维视频画面 -->
    <div class="w-full min-h-[calc(100%-351px)]">
      <CategoryTitle class="my-10px" title="三维视频画面" />
      <div class="w-full h-[calc(100%-70px)]">
        <el-table :data="tableData" height="100%" @row-click="handleRowClick" highlight-current-row>
          <el-table-column label="" width="20">
            <template>
              <div class="selected-row"></div>
            </template>
          </el-table-column>
          <el-table-column label="摄像头名称" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column label="所属区域" prop="areaName" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <span
                class="text-blue-500 bold hover:text-blue-200 cursor-pointer"
                @click="play(scope.row)"
                >播放</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="currentPage"
          background
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 摄像头弹窗 -->
    <videoDialog
      v-if="videoDialogShow"
      :show.sync="videoDialogShow"
      :code="cameraCode"
      :name="cameraName"
      :pIid="pIid"
      :showControlPanel="true"
      :manufacturerCode="manufacturerCode"
      :daHuaParams="daHuaParams"
    ></videoDialog>
  </div>
</template>

<script>
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import { IotApi } from '@wiz-api/measuring-point-management'
import dayjs from 'dayjs'
import videoDialog from '../components/video/videoDialog'

const iotApi = new IotApi()

export default {
  name: 'EmergencyResponseDetailRight',
  props: {
    transferProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    CategoryTitle,
    videoDialog,
  },
  data() {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      emergencyItems: [],
      emergencyPlanPerson: [],
      importantGroups: new Map([
        ['名称', 'name'],
        ['代码', 'code'],
        ['实时值', 'realTimeValue'],
        ['时间', 'time'],
      ]),
      importantGroupsParams: [],
      videoDialogShow: false,
      manufacturerCode: 'Hik', // 厂商
      pIid: '', // 宇视才需要这个pIid
      cameraCode: '',
      cameraName: '',
      daHuaParams: {},
    }
  },
  watch: {
    transferProps: {
      handler(val) {
        this.getEmergencyFlows()
      },
      deep: true,
    },
  },
  created() {
    this.getEmergencyFlows()
    this.getDynamicTableData()
    this.getThreeDimensionalVideoList()
  },
  methods: {
    // 获取左侧流程数据并筛选出人员
    async getEmergencyFlows() {
      axios({
        method: 'GET',
        url: `${this.transferProps.baseUrl}/openapi/ecologynew/detail/V1.0?token=portal_js&id=${this.transferProps.row.id}`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.emergencyItems = res.data.data || []
          let groupLeaders = []
          let members = []
          this.emergencyItems.forEach((item) => {
            groupLeaders = groupLeaders.concat(item.groupLeader.split(','))
            members = members.concat(item.member.split(','))
          })
          this.emergencyPlanPerson = [...new Set(groupLeaders.concat(members))]
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取重要机组参数列表
    async getDynamicTableData() {
      axios({
        method: 'GET',
        url: `${this.transferProps.baseUrl}/openapi/point_by_crew/V1.0?token=portal_js`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
        responseType: 'json',
      })
        .then((res) => {
          this.importantGroupsParams =
            res.data.data.map((item) => {
              return {
                ...item,
                pointId: item.pointId.toString(),
                realTimeValue: '',
                time: '',
              }
            }) || []
          const idList = this.importantGroupsParams.map((item) => {
            return item.pointId
          })
          idList.length > 0 && this.getValueForMeasuringPoints(idList)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 测点id获取iot实时数据列表
    async getValueForMeasuringPoints(idList) {
      const params = {
        ids: idList.join(','),
      }
      const [err, res] = await iotApi.getValueForMeasuringPoints(params)
      if (!err) {
        this.importantGroupsParams.forEach((item) => {
          for (let i = 0; i < res.data.length; i += 1) {
            if (item.pointId === res.data[i].measuringPointId) {
              item.realTimeValue = res.data[i].values[0].value.toFixed(2)
              item.time = dayjs(
                Number(res.data[i].values[0].timeStamp.toString().padEnd(13, '0'))
              ).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        })
      }
    },
    // 获取三维视频画面列表
    async getThreeDimensionalVideoList() {
      const res = await axios({
        method: 'post',
        // 低代码才有全局变量ApiBase
        url: `${ApiBase}/api/FormEngine/getTableData`,
        data: {
          TableName: 'diy_plan_relation',
          _PageIndex: 1,
          _PageSize: 1,
          _SearchEqual: {
            planId: this.transferProps.row.id,
          },
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('authorization')}`,
        },
      })
      if (res.data && res.data.Code === 1 && res.data.Data) {
        const data = res.data.Data.map((item) => {
          return {
            ...item,
            relationMonitor: JSON.parse(item.relationMonitor),
          }
        })[0]
        if (Array.isArray(data.relationMonitor)) {
          this.tableData = data.relationMonitor
          this.total = data.relationMonitor.length
        }
      }
    },
    handlePageChange(newPage) {
      this.currentPage = newPage
    },
    // 定位监控
    handleRowClick(row) {
      if (row.threeDAngleView) {
        const cameraParams = JSON.parse(row.threeDAngleView)
        this.transferProps.cloudRender.Camera.moveCamera('CameraParam', cameraParams)
      }
    },
    async play(row) {
      this.pIid = row.pIid
      this.cameraCode = row.code || ''
      this.cameraName = row.name || ''
      this.manufacturerCode = row.manufacturerCode || 'Hik'
      this.daHuaParams = {
        id: row.id,
        code: row.code,
      }
      this.videoDialogShow = true
      const str = sessionStorage.getItem('cameraMarkList')
      if (str && JSON.parse(str).length) {
        const markList = JSON.parse(str)
        const index = _.findIndex(markList, ['id', row.id])
        if (index > -1) {
          const treeData = await this.transferProps.player.Native.ModelTree.getRootItems()
          this.transferProps.player?.Native.Camera.moveToPos(
            JSON.parse(markList[index].threeDPosition),
            treeData[0]?.nodePtr,
            50,
            2
          )
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
